
// Prop、Watch、Emit、Model、Inject
import { Component, Vue } from 'vue-property-decorator';
// import { Getter, Action } from 'vuex-class'
import Header from '@/common/header.vue';
import Footer from '@/common/footer.vue';
import { getBargain, getBargainUser, bargaining } from '@/services/http';
import QRCode from 'qrcodejs2';
import Swiper from 'swiper';
import 'swiper/dist/css/swiper.min.css';
import { Mutation } from 'vuex-class';
import { readCookie } from '@/tools/tools';

@Component({
  components: {
    Header,
    Footer
  }
})
export default class extends Vue {
  // @Getter('xxx') xxx: any
  // @Action('xxx') xxx!: Function
  // activated() {}

  bargainingList: any[] = []; // 砍价中列表

  bargainList: any[] = []; // 砍价商品列表

  bargainUser: any[] = []; // 砍价参与用户

  dialogVisible: boolean = false; // 二维码弹窗控制

  qrcode: any = ''; // 二维码

  qrcodeUrl: any = '' // 二维码地址

  productId: any = '';

  mySwiper: any = '';

  pageNo: number = 1

  totalnumber: number = 0

  pageSize: number = 15

  @Mutation('order/CONFIRMORDER') CONFIRMORDER!: Function;

  created() {
    this.init();
  }

  handleCurrentChange(val: number) {
    this.pageNo = val;
    this.getBargain();
  }

  handleSizeChange(val: number) {
    this.pageSize = val;
    this.getBargain();
  }

  // 初始化
  async init() {
    if (readCookie('accessToken')) await this.bargaining();
    await this.getBargain();
    await this.getBargainUser();
  }

  // 去付款
  goOrderConfirm(item: any) {
    const confirmlist = [
      {
        freight: null,
        productId: item.productId,
        id: item.productPriceId,
        mallImage: {
          source_url: item.product.listImagePath.sourceUrl,
          product_name: item.product.productName
        },
        natureList: item.natureList,
        num: 1,
        price: (item.originalAmount - item.bargainAmount).toFixed(2),
        totalPrice: (item.originalAmount - item.bargainAmount).toFixed(2)
      }
    ];
    this.CONFIRMORDER(confirmlist);
    this.$router.push(`/orderconfirm?type=2&configId=${item.configId}&bargain=bargain`);
  }

  // 打开二维码弹窗
  openDialog(id: number) {
    this.productId = id;
    this.dialogVisible = true;
    this.qrcodeUrl = process.env.VUE_APP_BASE_API;
    this.$nextTick(() => {
      (this as any).$refs.qrCodeUrl.innerHTML = '';
      this.qrcode = new QRCode(this.$refs.qrCodeUrl, {
        text: `${process.env.VUE_APP_BASE_API}/m/bargaining?id=${this.productId}`,
        width: 180,
        height: 180,
        colorDark: '#000000',
        colorLight: '#ffffff',
        correctLevel: QRCode.CorrectLevel.H
      });
    });
  }

  // 获取砍价中列表
  async bargaining() {
    const res: any = await bargaining({
      companyId: 1
    });
    if (res.data && res.data.code === 100) {
      this.bargainingList = res.data.data.map((item: any) => {
        const data = item;
        data.hour = Math.floor(data.surplus / 3600) < 10 ? `0${Math.floor(data.surplus / 3600)}` : Math.floor(data.surplus / 3600);
        data.minute = Math.floor(((data.surplus / 60) % 60)) < 10 ? `0${Math.floor(((data.surplus / 60) % 60))}` : Math.floor(((data.surplus / 60) % 60));
        data.second = Math.floor((data.surplus % 60)) < 10 ? `0${Math.floor((data.surplus % 60))}` : Math.floor((data.surplus % 60));
        if (data.surplus > 0) {
          const timer = setInterval(() => {
            if (data.hour === '00' && data.minute === '00' && data.second === '00') {
              clearInterval(timer);
              this.$router.go(0);
              return;
            }
            data.hour = Math.floor(data.surplus / 3600) < 10 ? `0${Math.floor(data.surplus / 3600)}` : Math.floor(data.surplus / 3600);
            data.minute = Math.floor(((data.surplus / 60) % 60)) < 10 ? `0${Math.floor(((data.surplus / 60) % 60))}` : Math.floor(((data.surplus / 60) % 60));
            data.second = Math.floor((data.surplus % 60)) < 10 ? `0${Math.floor((data.surplus % 60))}` : Math.floor((data.surplus % 60));
            data.surplus -= 1;
          }, 1000);
        }
        return data;
      });
    }
  }

  // 获取砍价列表
  async getBargain() {
    const anchor = readCookie('anchor');
    const res: any = await getBargain({
      pageNo: this.pageNo,
      pageSize: this.pageSize,
      companyId: 1,
      model: anchor ? anchor.model : '',
      equipVersion: anchor ? anchor.equipVersion : '',
      equipMeid: anchor ? anchor.equipMeid : ''
    });
    if (res.data && res.data.code === 100) {
      this.bargainList = res.data.data.list ? res.data.data.list : [];
      this.totalnumber = res.data.data.total;
      this.bargainList = this.bargainList.map((item: any) => {
        const data: any = item;
        if (data.lowest_price.split(',')[0]) {
          // const lowPrice = data.lowest_price.split(',')[0].split('.')[0];
          // const lowPrice2 = data.lowest_price.split(',')[0].split('.')[1];
          // data.lowPrice = lowPrice - data.bargain_amount;
          // data.lowPrice2 = lowPrice2;
          const lowPrice = ((data.lowest_price.split(',')[0] || data.lowest_price) - data.bargain_amount).toFixed(2).toString();
          data.lowPrice = lowPrice.substring(0, lowPrice.indexOf('.'));
          data.lowPrice2 = lowPrice.substring(lowPrice.indexOf('.') + 1, lowPrice.length);
        }
        return data;
      });
    }
  }

  // 获取参与情况
  async getBargainUser() {
    const res: any = await getBargainUser({ num: 10, companyId: 1 });
    if (res.data.code === 100) {
      this.bargainUser = res.data.data.slice(0, 20);
      this.$nextTick(() => {
        this.mySwiper = new Swiper('.swiper-container', {
          autoplay: 5000,
          direction: 'vertical',
          speed: 500
        });
      });
    }
  }

  // 复制成功
  private onCopy() {
    this.$message.success('复制成功');
  }

  // 复制失败
  private onError() {
    this.$message.error('该浏览器不支持自动复制，请手动复制');
  }
}
